import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ModernNavbar from './components/ModernNavbar.js';
import Home from './pages/Home.js';
import ResponsiveHome from './components/ResponsiveHome.js';
import Shop from './pages/Shop.js';
import About from './pages/About.js';
import Contact from './pages/Contact.js';
import FishDetail from './pages/FishDetail.js';
import Admin from './pages/Admin.js';
import CareGuide from './pages/CareGuide.js';
import FAQ from './pages/FAQ.js';
import ModernFooter from './components/ModernFooter.js';
import ScrollButtons from './components/ScrollButtons.js'; // Import the new component
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ModernNavbar />
        <div className="main-content"> {/* Added a wrapper div for main content */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/responsive-demo" element={<ResponsiveHome />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/care-guide" element={<CareGuide />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/fish/:id" element={<FishDetail />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </div>
        <ModernFooter />
        <ScrollButtons /> {/* Add the scroll buttons */}
      </div>
    </Router>
  );
}

export default App;
